import React, { useContext, useEffect, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import {
  Alert,
  Button,
  Form,
  Spinner,
  Card,
  Row,
  Col,
  Table,
  Accordion,
  Modal,
} from "react-bootstrap";
import moment from "moment";
import * as Yup from "yup";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { getInputClasses } from "../../../_utils/getInputclasses";
import AlertError from "../../../components/AlertError";
import { Divider } from "@material-ui/core";
import { getAllByCase, save } from "../../services/documentsService";
import { GetUser } from "../../../../_metronic/_helpers";
import { shallowEqual, useSelector } from "react-redux";

import BlockCaseContext from "../../../contexts/BlockCaseContext";
import {isNotEmpty} from "../../../_utils/checkObjectEmpty";

export const Documentation = (props) => {
  return (
    <>
      <Card>
        <Card.Header>
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey={props.eventKey}
          >
            Documentación
          </Accordion.Toggle>
          <i className={`fa ${props.icon}`} style={{position:"absolute", right:"0", marginRight:"15px", marginTop:"10px" }}></i>
          <i className={`fa ${props.icone}`} style={{position:"absolute", right:"0", marginRight:"35px", marginTop:"10px" }}></i>
        </Card.Header>
        <Accordion.Collapse eventKey={props.eventKey}>
          <Card.Body>
            <ContentDocumentation {...props} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export const ContentDocumentation = (props) => {
  return (
    <>
      <Alert
        variant="dark"
        className="text-center mt-4"
        style={{ fontSize: "14px" }}
      >
        Documentacion
      </Alert>

      <Card>
        <Card.Body>
          <FormDocumentation {...props} />
        </Card.Body>
      </Card>
    </>
  );
};

const FormDocumentation = (props) => {
  const { data } = props;
  const { slug } = props.match?.params || props;

  const validationSchema = Yup.object().shape({
    file: Yup.mixed()
      .required("El campo es requerido")
      .test('fileFormat', 'Solo se permiten archivos PDF', (value) => {
        return value && ['application/pdf'].includes(value.type);
      }),
    document_type: Yup.string()
      .required("El campo es requerido"),
  });

  const [userAuth] = useState({ ...GetUser().user });
  const [, setShouldBlockCase] = useContext(BlockCaseContext);
  const [documents, setDocuments] = useState([]);
  const [viewerIndex, setViewerIndex] = useState(null);
  const [viewerPdfUrl, setViewerPdfUrl] = useState("");
  const [viewerLoading, setViewerLoading] = useState(false);
  const [viewerError, setViewerError] = useState("");

  const allowSelectiveDownload = !!props.allowSelectiveDownload;
  const [selectedDocumentIds, setSelectedDocumentIds] = useState([]);
  const [downloadingSelection, setDownloadingSelection] = useState(false);
  const [downloadError, setDownloadError] = useState("");

  const onSubmit = (values, { setStatus, setSubmitting, resetForm }) => {
    setTimeout(() => {
      let formData = new FormData();
      formData.append("file", values.file);
      formData.append("user_id", userAuth.idUser);
      formData.append("document_type", values.document_type);
      formData.append("slug", slug);
      save(formData)
        .then( response => {
          getAllByCase(data.id).then(data => setDocuments(data.data));
          setShouldBlockCase(false);
          setInitialDocument({ file: "", document_type: ""});
          resetForm();
          setInputKey(Math.random().toString(36));
        })
        .catch( err => setStatus(`Ocurrio algun error al guardar`));
      setSubmitting(false);
    }, 1000);
  }

  useEffect(() => {
    if (isNotEmpty(data)) {
      getAllByCase(data.id).then(data => setDocuments(data.data));
    }
  }, [data]);

  const [initialDocument, setInitialDocument] = useState({ file: "", document_type: ""});

  const typesDocument = props.typesDocument || [
    "Aviso de Accidente", "Carta de Autorización", "Comprobante de seguro o poliza", "Denuncia ante MP",
    "Desvíos Aplicados", "Estudios de Gabinete", "Estudios de Laboratorio", "Estudios que Confirmen DX",
    "Historia Clinica", "Honorarios Médicos", "Identificacion", "Informe Medico Actualizado", "Nota de Evolución",
    "Nota Postquirurgica", "Resumen Medico Actualizado", "Otro",
  ];

  const [inputKey, setInputKey] = useState("");

  const {token} = useSelector(
    ({auth}) => ({
        token: auth.authToken,
    }),
    shallowEqual
  );

  useEffect(() => {
    setSelectedDocumentIds([]);
  }, [documents]);

  const toggleDocumentSelected = (documentId) => {
    setSelectedDocumentIds((current) =>
      current.includes(documentId)
        ? current.filter((id) => id !== documentId)
        : [...current, documentId]
    );
  };

  const toggleSelectAllDocuments = () => {
    setSelectedDocumentIds((current) =>
      current.length === documents.length ? [] : documents.map((document) => document.id)
    );
  };

  const sanitizeFileName = (name) =>
    (name || "documento")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9_-]+/g, "_");

  const fetchDocumentBlob = async (document) => {
    const secureUrl = document.url.replace(/^https?:\/\//i, `${window.location.protocol}//`);
    const response = await fetch(secureUrl, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (!response.ok) throw new Error("PDF request failed");
    return response.blob();
  };

  const downloadSelectedDocuments = async () => {
    const selectedDocuments = documents.filter((document) => selectedDocumentIds.includes(document.id));
    if (selectedDocuments.length === 0) return;

    setDownloadError("");
    setDownloadingSelection(true);
    try {
      const namedDocuments = selectedDocuments.map((document, idx) => ({
        document,
        fileName: `${idx + 1}_${sanitizeFileName(document.documentType)}.pdf`,
      }));

      if (namedDocuments.length >= 3) {
        const zip = new JSZip();
        const blobs = await Promise.all(namedDocuments.map(({ document }) => fetchDocumentBlob(document)));
        blobs.forEach((blob, idx) => zip.file(namedDocuments[idx].fileName, blob));
        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, `Documentos_${data?.id || slug}.zip`);
      } else {
        for (const { document, fileName } of namedDocuments) {
          const blob = await fetchDocumentBlob(document);
          saveAs(blob, fileName);
          if (namedDocuments.length > 1) {
            await new Promise((resolve) => setTimeout(resolve, 300));
          }
        }
      }
    } catch (e) {
      setDownloadError("No se pudieron descargar uno o más documentos seleccionados.");
    } finally {
      setDownloadingSelection(false);
    }
  };

  useEffect(() => {
    if (viewerIndex === null) {
      setViewerPdfUrl("");
      setViewerError("");
      return undefined;
    }

    const currentDocument = documents[viewerIndex];
    if (!currentDocument?.url) {
      setViewerError("El documento no tiene un archivo PDF disponible.");
      return undefined;
    }

    let cancelled = false;
    let objectUrl = "";
    setViewerLoading(true);
    setViewerPdfUrl("");
    setViewerError("");

    const secureUrl = currentDocument.url.replace(/^https?:\/\//i, `${window.location.protocol}//`);
    fetch(secureUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
      .then(response => {
        if (!response.ok) throw new Error("PDF request failed");
        return response.blob();
      })
      .then(blob => {
        if (cancelled) return;
        objectUrl = window.URL.createObjectURL(blob);
        setViewerPdfUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setViewerError("No se pudo cargar el documento PDF.");
      })
      .finally(() => {
        if (!cancelled) setViewerLoading(false);
      });

    return () => {
      cancelled = true;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [documents, token, viewerIndex]);

  useEffect(() => {
    if (viewerIndex === null) return undefined;

    const handleViewerKeys = (event) => {
      if (event.key === "ArrowLeft") {
        setViewerIndex(current => Math.max(0, current - 1));
      }
      if (event.key === "ArrowRight") {
        setViewerIndex(current => Math.min(documents.length - 1, current + 1));
      }
    };

    window.addEventListener("keydown", handleViewerKeys);
    return () => window.removeEventListener("keydown", handleViewerKeys);
  }, [documents.length, viewerIndex]);

  if (props.attachOptions) {
    const other = typesDocument.pop()
    // typesDocument.unshift(other);
    typesDocument.push(...props.typesDocumentToAttach)
    typesDocument.push(other);
  }

  return (
    <>
      <Table responsive striped bordered hover>
        <thead>
          <tr>
            {allowSelectiveDownload && (
              <th>
                <Form.Check
                  type="checkbox"
                  checked={documents.length > 0 && selectedDocumentIds.length === documents.length}
                  onChange={toggleSelectAllDocuments}
                  aria-label="Seleccionar todos los documentos"
                />
              </th>
            )}
            <th>Documento</th>
            <th>Documento</th>
            <th>Pagina</th>
            <th>Usuario</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          {documents?.map( (document, idx) => (
            <tr key={idx}>
              {allowSelectiveDownload && (
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selectedDocumentIds.includes(document.id)}
                    onChange={() => toggleDocumentSelected(document.id)}
                    aria-label={`Seleccionar ${document.documentType}`}
                  />
                </td>
              )}
              <td>{idx + 1}</td>
              <td>{document.documentType}</td>
              <td>
                <Button
                  type="button"
                  size="sm"
                  variant="outline-primary"
                  onClick={() => setViewerIndex(idx)}
                >
                  Ver PDF
                </Button>
              </td>
              <td>{document.user.userName}</td>
              <td>{moment(document.createdAt).format('DD/MM/YYYY HH:mm:ss A')}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      {allowSelectiveDownload && (
        <div className="mb-4">
          <Button
            type="button"
            variant="success"
            disabled={selectedDocumentIds.length === 0 || downloadingSelection}
            onClick={downloadSelectedDocuments}
          >
            {downloadingSelection && (
              <Spinner as="span" animation="border" size="sm" className="mr-2" />
            )}
            Descargar seleccionados ({selectedDocumentIds.length})
          </Button>
          {downloadError && (
            <Alert variant="danger" className="mt-3 mb-0" role="alert">
              {downloadError}
            </Alert>
          )}
        </div>
      )}

      <Modal
        show={viewerIndex !== null}
        onHide={() => setViewerIndex(null)}
        size="xl"
        centered
        aria-labelledby="pdf-viewer-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="pdf-viewer-title">
            {documents[viewerIndex]?.documentType || "Documento PDF"}
          </Modal.Title>
          <span className="ml-auto mr-4 text-muted">
            {viewerIndex !== null ? viewerIndex + 1 : 0} de {documents.length}
          </span>
        </Modal.Header>
        <Modal.Body style={{ minHeight: "70vh", padding: 0 }}>
          {viewerLoading && (
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
              <Spinner animation="border" role="status" />
              <span className="ml-3">Cargando documento…</span>
            </div>
          )}
          {viewerError && (
            <Alert variant="danger" className="m-4" role="alert">
              {viewerError}
            </Alert>
          )}
          {!viewerLoading && !viewerError && viewerPdfUrl && (
            <iframe
              src={viewerPdfUrl}
              title={documents[viewerIndex]?.documentType || "Documento PDF"}
              style={{ width: "100%", height: "70vh", border: 0, display: "block" }}
            />
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button
            type="button"
            variant="secondary"
            disabled={viewerIndex === null || viewerIndex === 0}
            onClick={() => setViewerIndex(current => current - 1)}
          >
            Anterior
          </Button>
          <Button
            type="button"
            variant="primary"
            disabled={viewerIndex === null || viewerIndex >= documents.length - 1}
            onClick={() => setViewerIndex(current => current + 1)}
          >
            Siguiente
          </Button>
        </Modal.Footer>
      </Modal>

      <Divider className="mt-5 mb-5" />
      <Formik initialValues={ initialDocument } enableReinitialize={true} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({values, errors, touched, handleChange, handleSubmit, setFieldValue, status, isSubmitting}) => (
          <>
            <AlertError status={status} />

            <Form onSubmit={handleSubmit}>
              <Row hidden={props.disabledAll}>
                <Col>
                  <Form.Group controlId="file">
                    <Form.Label>Archivo</Form.Label>
                    <Form.Control
                      key={inputKey || ''}
                      disabled={props.disabledAll}
                      type="file"
                      name="file"
                      accept="application/pdf"
                      onChange={(event) => {
                        setFieldValue("file", event.currentTarget.files[0]);
                      }}
                      className={`${getInputClasses(touched, errors, "file")}`}
                    />
                    <ErrorMessage name="file">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="document_type">
                    <Form.Label>Tipo de Documento</Form.Label>
                    <Form.Control
                      disabled={props.disabledAll}
                      as="select"
                      name="document_type"
                      value={values.document_type}
                      onChange={handleChange}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "document_type"
                      )}`}
                    >
                      <option value="">SELECCIONA UNA OPCIÓN...</option>
                      {typesDocument.map( (typeDocument, idx) => (
                        <option key={idx} value={typeDocument}>{typeDocument}</option>
                      ))}
                    </Form.Control>
                    <ErrorMessage name="document_type">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
              <Button variant="primary" type="submit" disabled={isSubmitting} hidden={props.disabledAll}>
                {isSubmitting && (
                  <Spinner
                    as="span"
                    animation="border"
                    variant="dark"
                    size="sm"
                  />
                )}
                Subir Documento
              </Button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default Documentation;
